import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidAngleRightIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Zm-3.1-5.8c0 .6.4 1 1 1 .2 0 .5-.1.7-.3l4.2-4.2c.4-.4.4-1 0-1.4l-4.2-4.2c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.5 3.5-3.5 3.5c-.2.2-.3.4-.3.7Z" clipRule="evenodd"/>
  </SvgIcon>
}

export default SolidAngleRightIcon
